import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_BASE}/api`;

// Auth is carried by a same-origin httpOnly cookie (set by the backend on login).
// withCredentials makes the browser attach that cookie to every XHR request.
// For <a href>/window.open/<img> downloads below, the same cookie rides along
// automatically (SameSite=Lax cookies are sent on all same-origin requests),
// so no token is ever exposed to JavaScript or placed in a URL.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function fileUrl(fileId) {
  return `${API}/files/${fileId}/download`;
}

export function pdfUrl(consultationId) {
  return `${API}/consultations/${consultationId}/pdf`;
}

export function patientQrUrl(patientId) {
  return `${API}/patients/${patientId}/qr`;
}

export function groomingPdfUrl(id) {
  return `${API}/grooming/${id}/pdf`;
}

export function boardingPdfUrl(id) {
  return `${API}/boarding/${id}/pdf`;
}

export function invoicePdfUrl(id) {
  return `${API}/invoices/${id}/pdf`;
}

export function reportExportUrl(fmt, params = {}) {
  const qp = new URLSearchParams(params).toString();
  return `${API}/admin/reports/export.${fmt}${qp ? `?${qp}` : ""}`;
}

export function backupDownloadUrl() {
  return `${API}/admin/backup`;
}

export function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(", ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
